import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import LinkButton from './custom/LinkButton';
import { mdiLink } from '@mdi/js';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100%',
    padding: '15px',
  },
  card: {
    overflow: 'hidden',
    width: '100%',
    maxWidth: '400px',
    maxHeight: '214px',
    margin: 'auto',
    borderRadius: '5px',
    boxShadow: '0px 10px 30px -5px rgba(0, 0, 0, 0.3)',
  },
  videoCard: {
    overflow: 'hidden',
    width: '100%',
    maxWidth: '400px',
    maxHeight: '300px',
    margin: 'auto',
  },
  image: {
    width: '100%',

    maxWidth: '400px',
  },
  scrollingWrapper: {
    overflowX: 'hidden',
    overflowY: 'scroll',
    whiteSpace: 'nowrap',
    height: ' 214px',
  },
  card2: {
    display: 'block',
  },
}));

export default function News() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid container style={{ textAlign: 'justify', marginTop: '10vh' }}>
        <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
          <h2>Latest projects</h2>
        </Grid>
        <Grid item xs={12} md={6} style={{ textAlign: 'center' }}>
          <h2>April 2021</h2>
          <img
            width='80px'
            src='https://amitturner.github.io/portfolio/images/projects/anitar_logo.png'
            alt='anitar.dev'
          />
          <h3>
            Anitar.dev is a fun design project to create animal avatars for web developers to use in their projects
          </h3>
          <LinkButton icon={mdiLink} link='https://anitar.dev' text='Explore Anitar.dev now' />
        </Grid>

        <Grid item xs={12} md={6} style={{ textAlign: 'center' }}>
          <h2>April 2020</h2>
          <img
            width='200px'
            src='https://amitturner.github.io/portfolio/images/projects/deciidy.png'
            alt='Deciidy.web.app'
          />
          <h3>
            Decidy was created to visualize the decision-making process and improve it. <br />
            Its still a working in progress.
          </h3>
          <LinkButton icon={mdiLink} link='http://Deciidy.web.app' text='Explore Decidy now' />
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <h2>March 2020</h2>
          <img
            width='200px'
            src='https://amitturner.github.io/portfolio/images/projects/logo_com.png'
            alt='whatHeight.com'
          />
          <h3>
            A tool built in React to allow height and size comparison of everything you ever wondered about.
            <br />
            with an updating database allowing users to upload their own pictures and also suggest additions and fixes
            to current lists.
          </h3>
          <LinkButton icon={mdiLink} link='http://whatheight.com' text='Explore whatHeight.com now' />
        </Grid>
      </Grid>
    </div>
  );
}
